<template>
  <div id="shopUi">
    <div class="head-title">
      <span class="head-text">店铺美化</span>
    </div>
    <div class="box">
      <div class="logo-box">
        <div>
          <div class="logoin_uodata">
            <div class="link-box">
              <input ref="choiceLogo1" type="file" @change="updata($event)" style="display:none" />
              <el-link type="primary" @click="choiceImage('logo1')">本地上传</el-link>
            </div>
          </div>
          <div class="unit_img">
            <vue-cropper
              mode="100%"
              :fixed="true"
              autoCrop
              :img="blob"
              ref="cropper"
              centerBox
              outputType="png"
            />
          </div>
        </div>
        <div>
          <div class="block">
            <el-avatar :size="100" :src="circleUrl"></el-avatar>
          </div>
          <div class="link-box" style="text-align:center">
            <el-link type="primary" @click="uploadImage('e','logo')">上传logo</el-link>
          </div>
        </div>
      </div>
      <div class="banner-box">
        <div>
          <div class="logoin_uodata">
            <div class="link-box" style="padding:20px">
              <input ref="choiceImg1" type="file" @change="updata1($event)" style="display:none" />
              <el-link type="primary" @click="choiceImage('banner1')">本地上传</el-link>
            </div>
          </div>
          <div style="width:1000px;height:183px">
            <vue-cropper
              autoCrop
              mode="100%"
              :img="banne_blob"
              :fixed="true"
              :fixedNumber="[5.5,1]"
              ref="cropper_banner"
              centerBox
              outputType="png"
            />
          </div>
        </div>
        <div class="banner-block">
          <el-image class="banner" fit="cover" :src="bannerUrl"></el-image>
          <div class="link-box">
            <input
              ref="choiceImg"
              @change="uploadImage($event,'banner')"
              @click="resetInput('banner')"
              type="file"
              style="display:none"
            />
            <el-link type="primary" @click="uploadImage_banner('e','banner')">上传banner图片</el-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { VueCropper } from "vue-cropper";
export default {
  components: {
    VueCropper
  },
  data() {
    return {
      serve: this.$store.state.serve,
      token: this.$cookies.get("shop_token"),
      circleUrl: "",
      bannerUrl: "",
      banner: "",
      blob: "",
      banne_blob: ""
    };
  },
  created() {
    this.showUserInfo();
    this.$store.state.shop_top = 0;
    this.$store.state.shop_left = "商铺美化";
  },
  methods: {
    updata(e) {
      this.blob = URL.createObjectURL(e.target.files[0]);
    },
    updata1(e) {
      this.banne_blob = URL.createObjectURL(e.target.files[0]);
    },
    choiceImage(type) {
      if (type == "banner") {
        this.$refs.choiceImg.dispatchEvent(new MouseEvent("click"));
      } else if (type == "logo") {
        this.$refs.choiceLogo.dispatchEvent(new MouseEvent("click"));
      } else if (type == "logo1") {
        this.$refs.choiceLogo1.dispatchEvent(new MouseEvent("click"));
      } else if (type == "banner1") {
        this.$refs.choiceImg1.dispatchEvent(new MouseEvent("click"));
      }
    },
    resetInput(type) {
      if (type == "banner") {
        this.$refs.choiceImg.value = "";
      } else if (type == "logo") {
        this.$refs.choiceLogo.value = "";
      }
    },
    dataURLtoFile: function(dataurl, filename) {
      //base64转换file对象
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    // , type
    uploadImage(e, type) {
      this.$refs.cropper.getCropData(file => {
        var inputFile = this.dataURLtoFile(file, "imgName");
        // var inputFile = $event.target.files[0];
        if (inputFile) {
          if (
            inputFile.type !== "image/jpeg" &&
            inputFile.type !== "image/png" &&
            inputFile.type !== "image/gif"
          ) {
            this.$alerts.error("不是有效的图片文件！", this.$message);
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: "正在上传...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          setTimeout(() => {
            loading.close();
          }, 5000);
          let formData = new FormData();
          formData.append("token", this.token);
          var upload_mthod = "";
          if (type == "banner") {
            formData.append("banner", inputFile);
            upload_mthod = "shop/save_banner";
          } else if (type == "logo") {
            formData.append("logo", inputFile);
            upload_mthod = "shop/save_logo";
          }
          this.axios.post(this.serve + upload_mthod, formData).then(res => {
            var data = res.data;
            if (data.status == "success") {
              this.$alerts.success("banner上传成功", this.$message);
              if (type == "banner") {
                this.bannerUrl = this.serve + data.data.banner;
              } else if (type == "logo") {
                this.circleUrl = this.serve + data.data.logo;
              }
            } else {
              this.$alerts.error("banner上传失败", this.$message);
            }
            loading.close();
          });
        } else {
          return;
        }
      });
    },
    uploadImage_banner(e, type) {
      this.$refs.cropper_banner.getCropData(file_banner => {
        var file_ba = this.dataURLtoFile(file_banner, "imgName");
        if (file_ba) {
          if (
            file_ba.type !== "image/jpeg" &&
            file_ba.type !== "image/png" &&
            file_ba.type !== "image/gif"
          ) {
            this.$alerts.error("不是有效的图片文件！", this.$message);
            return;
          }
          const loading = this.$loading({
            lock: true,
            text: "正在上传...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)"
          });
          setTimeout(() => {
            loading.close();
          }, 5000);
          let formData = new FormData();
          formData.append("token", this.token);
          var upload_mthod = "";
          if (type == "banner") {
            formData.append("banner", file_ba);
            upload_mthod = "shop/save_banner";
          } else if (type == "logo") {
            formData.append("logo", file_ba);
            upload_mthod = "shop/save_logo";
          }
          this.axios.post(this.serve + upload_mthod, formData).then(res => {
            var data = res.data;
            if (data.status == "success") {
              this.$alerts.success("banner上传成功", this.$message);
              if (type == "banner") {
                this.bannerUrl = this.serve + data.data.banner;
              } else if (type == "logo") {
                this.circleUrl = this.serve + data.data.logo;
              }
            } else {
              this.$alerts.error("banner上传失败", this.$message);
            }
            loading.close();
          });
        } else {
          return;
        }
      });
    },

    showUserInfo() {
      const loading = this.$loading({
        lock: true,
        text: "正在加载...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      setTimeout(() => {
        loading.close();
      }, 5000);
      var where = {
        token: this.token
      };
      this.axios
        .get(this.serve + "shop/show_user_info", { params: where })
        .then(res => {
          var data = res.data;
          if (data.status == "success") {
            if (data.data.banner) {
              this.bannerUrl = this.serve + data.data.banner;
            }
            if (data.data.logo) {
              this.circleUrl = this.serve + data.data.logo;
            }
          } else {
            this.$alerts.error("请求失败", this.$message);
          }
          loading.close();
        });
    },
    onSubmit() {}
  }
};
</script>
<style lang="scss">
#shopUi {
  .head-title {
    width: 1060px;
    height: 46px;
    background: rgba(238, 238, 238, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: rgba(51, 51, 51, 1);
    line-height: 46px;
    text-align: left;
  }
  .head-text {
    margin-left: 16px;
  }
  .box {
    width: 1060px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    .logo-box {
      border-bottom: 1px solid gray;
      display: flex;
      justify-content: space-evenly;
      padding-bottom: 30px;
      .logoin_uodata {
        padding: 20px;
      }
      .unit_img {
        width: 400px;
        height: 300px;
      }
      .block {
        margin-top: 50px;
        .link-box {
          text-align: center;
        }
      }
    }
    .banner-box {
      min-height: 300px;
      margin-top: 20px;
      margin-bottom: 100px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .banner-block {
        margin-top: 20px;
        .link-box {
          text-align: center;
        }
        .banner {
          max-width: 1000px;
          height: 200px;
        }
      }
    }
  }
}
</style>